import { Form, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import './secciones.scss';
import { EVENTOS } from 'constants/tipoMonitoreos';

const SeccionComplemento = ({ form, tipoActa }) => {
  return (
    <div>
      <Form form={form} layout="horizontal">
        <div className="container-datos">
          {tipoActa === EVENTOS && (
            <>
              <Form.Item name="identificadorEvento">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ identificadorEvento: target.checked });
                  }}>
                  Identificador del evento
                </Checkbox>
              </Form.Item>
              <Form.Item name="duracionEvento">
                <Checkbox
                  className="check-campos"
                  onChange={({ target }) => {
                    form.setFieldsValue({ duracionEvento: target.checked });
                  }}>
                  Duración del evento
                </Checkbox>
              </Form.Item>
            </>
          )}
          <Form.Item name="manifestacionComp">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ manifestacionComp: target.checked });
              }}>
              Manifestación del compareciente
            </Checkbox>
          </Form.Item>
          <Form.Item name="otrosHechos">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ otrosHechos: target.checked });
              }}>
              Otros Hechos
            </Checkbox>
          </Form.Item>
          <Form.Item name="infoAdicionalVisita">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ infoAdicionalVisita: target.checked });
              }}>
              Información adicional
            </Checkbox>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default SeccionComplemento;

SeccionComplemento.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired,
  tipoActa: PropTypes.number.isRequired
};
